<!-- <p>user-follower-view works!</p> -->

<div class="wrapper">

    <!-- Aside End -->
    <main class="middle-content" >
        <!-- Page Title Start -->
        <div class="page_title_block">
            <h1 class="page_title">View Follower</h1>
        </div>
        <!-- Page Title End -->
        <div class="content-section">
            <div class="order-view mt30 max-WT-700 mrgn-0-auto">
                <div class="main-block-innner mb40 mt40">
                    <div class="add-store-block1 input-style" >
                        <div class="form-group row ">
                            <label class="col-md-3" >Follower Id</label>
                            <label class="col-md-1"> : </label>
                            <label class="col-md-8"> {{veiwfollowerId?.followerId?._id}} </label>
                        </div>
                        <div class="form-group row ">
                            <label class="col-md-3">Name</label>
                            <label class="col-md-1"> : </label>
                            <label class="col-md-8"> {{(veiwfollowerId?.followerId?.fullName | titlecase)||'--'}} </label>
                        </div>
                        <div class="form-group row ">
                            <label class="col-md-3">Username</label>
                            <label class="col-md-1"> : </label>
                            <label class="col-md-8"> {{veiwfollowerId?.followerId?.userName || '--'}} </label>
                        </div>
                        <div class="form-group row ">
                            <label class="col-md-3">Email</label>
                            <label class="col-md-1"> : </label>
                            <label class="col-md-8"> {{veiwfollowerId?.followerId?.email ||'--'}} </label>
                        </div>
                        <div class="form-group row ">
                            <label class="col-md-3">Phone Number </label>
                            <label class="col-md-1"> : </label>
                            <label class="col-md-8"> {{veiwfollowerId?.followerId?.countryCode}} {{veiwfollowerId?.followerId?.phoneNumber||'--'}} </label>
                        </div>

                        <div class="form-group row ">
                            <label class="col-md-3">Request Status</label>
                            <label class="col-md-1"> : </label>
                            <label class="col-md-8"> {{(veiwfollowerId?.request |titlecase) || '--' }} </label>
                        </div>
                        <div class="form-group row ">
                            <label class="col-md-3" >Created Date & Time</label>
                            <label class="col-md-1"> : </label>
                            <label class="col-md-8"> {{veiwfollowerId?.createdAt | date:'medium'}}</label>
                        </div>
               
                        <div class="text-center mt40">
                            <!-- <a href="javascript:void(0)" class="btn btn-theme  max-WT-200 font-100 btn-green mr-2" (click)="saveAboutUS()">Update</a> -->
                            <a href="javascript:void(0)" class="btn btn-theme  max-WT-200 font-100 btn-grey ml5" (click)="listfollower(veiwfollowerId?.userId,'user-follower')">Back</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
    <!-- Middle Content End -->
</div>
